import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Feature, RoomCommands, RoomProperties } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';
import { CommissioningService } from '../../../commissioning/commissioning.service';
import { CommissioningDeleteRoomConfirmModalComponent } from '../../../commissioning';
import { CloseEventDialog } from '../../../commissioning/commissioning-delete-device-confirm-modal/commissioning-delete-device-confirm-modal.component';

@Component({
  selector: 'app-all-added-rooms-modal',
  templateUrl: './all-added-rooms-modal.component.html',
  styleUrls: ['./all-added-rooms-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllAddedRoomsModalComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  rooms: Feature<RoomProperties, RoomCommands>[] = [];

  constructor(
    public dialogRef: MatDialogRef<AllAddedRoomsModalComponent>,
    public installationFeaturesStore: InstallationFeaturesStore,
    private commissioningService: CommissioningService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.installationFeaturesStore.fixedRooms$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((rooms) => {
        this.rooms = rooms;
        this.cdr.detectChanges();

        if (rooms && !rooms.length) {
          this.dialogRef.close();
        }
      });
  }

  onDeleteRoomAttempt(room: Feature<RoomProperties, RoomCommands>): void {
    const dialogRef = this.dialog.open(CommissioningDeleteRoomConfirmModalComponent, {
      width: '715px',
      panelClass: 'commissioning-delete-room-confirm-dialog',
      data: {
        room,
      },
    });

    dialogRef.afterClosed().subscribe((event: CloseEventDialog) => {
      if (event.confirmed) {
        this.commissioningService.deleteRoom(room);
        this.dialogRef.close();
        if (event.shouldDeactivateSRC) {
          this.commissioningService.deactivateSRC();
        }
      }
    });
  }

  onEditRoom(room: Feature<RoomProperties, RoomCommands>): void {
    this.commissioningService.openEditRoomDialog(room);
  }

  onAddRoom(): void {
    this.commissioningService.openAddRoomDialog();
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
